import { render } from "./combo-input.vue?vue&type=template&id=4f2e99d1&scoped=true"
import script from "./combo-input.vue?vue&type=script&lang=js"
export * from "./combo-input.vue?vue&type=script&lang=js"

import "./combo-input.vue?vue&type=style&index=0&id=4f2e99d1&lang=scss&scoped=true"

import exportComponent from "/home/node/ks-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f2e99d1"]])

export default __exports__